export const FormValidations = {
    FileMaxSize: 15000000, // 15Mo
};
